// Which Hub tables read as cards on a phone. DOM-free on purpose (a structural
// type, not HTMLTableElement), so the node-pool tests can import it.

/** Tables that have their own phone layout; never cardified. */
export const CARD_TABLE_SKIP = ["mkt-tbl--grid", "mkt-tbl--today", "mkt-tbl--eff", "mkt-tbl--brief", "mkt-tbl--hist"] as const;

export function wantsCards(table: { classList: { contains(c: string): boolean } }): boolean {
  if (!table.classList.contains("mkt-tbl")) return false;
  return !CARD_TABLE_SKIP.some((c) => table.classList.contains(c));
}
